import { LocalePlayer } from '../en/player'

const player: LocalePlayer = {
  searchPlayers: '搜索选手',
  playerProfile: '选手档案',
  MALE: '男性',
  FEMALE: '女性',
  signUpToSeeInfo: '注册查看球员状态和比赛历史',
  loginToSeeInfo: `登录或创建账户以查看该用户的胜负记录、平均得分、平均搭档和对手DUPR评分、半衰期、比赛历史等信息。`,
  profileUnlock: {
    title: '使用解锁次数？',
    subtitle: '使用一次免费查看资料的机会',
    unlock: '解锁',
    limitReached: '已达上限',
    limitReachedSubtitle: '升级到 DUPR+ 即可无限查看个人资料',
    upgrade: '升级',
    upgradeLink: '升级解锁无限',
    viewsLeftShort_one: '剩 {{count}}',
    viewsLeftShort_other: '剩 {{count}}',
    infoTitle: '免费查看资料',
    info: '您有 {{count}} 次免费查看资料的机会。',
    resets: '{{when}}重置。',
    banner: {
      viewsLeft_one: '剩余 {{count}} 次查看',
      viewsLeft_other: '剩余 {{count}} 次查看',
      runningLow: '您的次数快用完了',
      freeViewsLeft_one: '还剩 {{count}} 次免费查看资料',
      freeViewsLeft_other: '还剩 {{count}} 次免费查看资料',
      unlockUnlimited: '解锁无限查看资料',
    },
  },
  filterRatingLocked: '升级到 DUPR+ 以按评分筛选',
  ratingLocked: '评分已锁定',
}

export default player
